var ajax_module_process = false;
$(window).scroll(function () {
    $('.lazy-module').each(function () {
        if (isElementVisible($(this), $(window))) {
            if (ajax_module_process === false) {
                ajax_module_process = true;
                var url = false;
                if($(this).hasClass('lazy-related')){
                    url = 'index.php?route=product/product/related_products&product_id=' + $(this).data('product-id');
                }else if($(this).hasClass('lazy-similar')){
                    url = 'index.php?route=product/product/similar_products&product_id=' + $(this).data('product-id');
                }else{
                    let product_id = 0;
                    const productPageProductIdSelector = $('input[name="product_id"]');
                    if(productPageProductIdSelector.length) {
                        product_id = productPageProductIdSelector.val();
                    }
                    url = 'index.php?route=extension/lazymodule&code=' + $(this).data('code') + '&product_id=' + product_id;
                }
                $(this).load(url, function () {
                    $(this).removeClass('lazy-module');
                    window.initSwipers();
                    ajax_module_process = false;
                });
            }
        }
    });
});
